// export const YIDA_BACKEND_API_URL = 'http://127.0.0.1:48080/admin-api';
export const YIDA_BACKEND_API_URL = 'https://api.yida-scm.com/admin-api';

export const YIDA_PROXY_API_BASE_URL = 'https://yida.itdida.com';
